import CalendarsPage from "@pages/CalendarsPage/CalendarsPage";
import CalendarView from "@pages/CalendarsPage/CalendarView/CalendarView";
import MeetingLayout from "@pages/CalendarsPage/MeetingLayout";
import ScheduleSection from "@pages/CalendarsPage/ScheduleSection/ScheduleSection";
import SchedulingSection from "@pages/CalendarsPage/SchedulingSection/SchedulingSection";
import CreateJobPage2 from "@pages/CreateJobPage2/CreateJobPage2";
import CreateMeetingInvitePage from "@pages/CreateMeetingInvitePage/CreateMeetingInvitePage";
import JobDetail from "@pages/JobPage/JobDetail/JobDetail";
import ApplicantSection from "@pages/JobPage/JobDetail/JobDetailSection/ApplicantSection";
import ShortlistedSection from "@pages/JobPage/JobDetail/JobDetailSection/ShortlistedSection";
import RecruiterHiringCompany from "@pages/recruiter/hiringCompany/hiringCompany";
import PartnerCompanies from "@pages/recruiter/hiringCompany/partnerCompanies/partnerCompanies";
import SearchHiringCompanies from "@pages/recruiter/hiringCompany/searchHiringCompanies/searchHiringCompanies";
import CompanyDetails from "@pages/SettingsPage/components/CompanyDetails";
import PersonalDetails from "@pages/SettingsPage/components/PersonalDetails";
import Username from "@pages/SettingsPage/components/Username";
import SettingsLayout from "@pages/SettingsPage/SettingsLayout";
import ChangePassword from "@pages/SettingsPage/components/ChangePassword";
import MySubscriptionPage from "@pages/SubscriptionPage/MySubscriptionPage";
import SubscriptionCheckoutPage from "@pages/SubscriptionPage/SubscriptionCheckoutPage";
import SubscriptionPlanPage from "@pages/SubscriptionPage/SubscriptionPlanPage";
import { Navigate, RouteObject } from "react-router-dom";
import { routerLoaders } from "router";
import RecruiterTrackerPage from "@pages/ActivityTracker/RecruiterTrackerPage";
import JobPageLayout from "@pages/JobPage/JobPageLayout";
import DashboardRecruiterPage from "@pages/Dashboard/DashboardRecruiter";
import RecruiterTrackerPageStatic from "@pages/ActivityTracker/RecruiterTrackerPageStatic";
import PaymentsSection from "@pages/recruiter/Transactions/sections/PaymentsSection";
import RefundsSection from "@pages/recruiter/Transactions/sections/RefundsSection";
import Balance from "@pages/recruiter/Transactions/sections/Balance";
import RefundSummary from "@pages/recruiter/Transactions/sections/RefundSummary";
import PaymentMethod from "@pages/recruiter/Transactions/sections/PaymentMethod";
import TransactionDetailPage from "@pages/TransactionPage/TransactionDetailPage";
import CandidateSection from "@pages/recruiter/ContactsPage/CandidatesSection/CandidatesSection";
import CompaniesSection from "@pages/recruiter/ContactsPage/CompaniesSection/CompaniesSection";
import AddCandidatePage from "@pages/recruiter/ContactsPage/CandidatesSection/AddCandidatePage/AddCandidatePage";
import AddCompanyPage from "@pages/recruiter/ContactsPage/CompaniesSection/AddCompanyPage/AddCompanyPage";
import ContactsPageLayout from "@pages/recruiter/ContactsPage/ContactsPageLayout";
import RequirementsDetails from "@pages/recruiter/RequirementDetails/RequirementDetails";
import RequirementsLayout from "@pages/recruiter/Requirements/RequirementsLayout";
import GeneralRequirements from "@pages/recruiter/Requirements/sections/GeneralRequirements";
import PartnerCompanyRequirements from "@pages/recruiter/Requirements/sections/PartnerCompanyRequirements";
import ViewByJob from "@pages/JobPage/components/ViewByJob";
import ViewByHiringCompany from "@pages/JobPage/components/ViewByHiringCompany";
import ViewByCandidate from "@pages/JobPage/ViewByCandidate/ViewByCandidate";
import JobListByCandidate from "@pages/JobPage/JobListByCandidate/JobListByCandidate";
import JobListByHiringCompany from "@pages/JobPage/JobListByHiringCompany/JobListByHiringCompany";
import ApplicantsListing from "@pages/JobPage/ApplicantsListing/ApplicantsListing";
import JobApplicantDetail from "@pages/JobPage/JobApplicantDetail/JobApplicantDetail";
import ScheduleSection1 from "@pages/CalendarsPage/ScheduleSection/ScheduleSection1";
import CandidateAppliedJobPage from "@pages/recruiter/CandidateAppliedJobPage/CandidateAppliedJobPage";
import AccountMembers from "@pages/SettingsPage/sections/AccountMembers";
import TransactionLayout from "@pages/recruiter/Transactions/TransactionLayout";
import JobDetailPageLayout from "@pages/JobDetailPage/JobDetailPageLayout";
import { JobDetails } from "@pages/JobDetailPage/JobDetails";

const { authLoader } = routerLoaders();

export const RecruiterRoutes: RouteObject[] = [
  {
    path: "/dashboard",
    loader: authLoader,
    element: <DashboardRecruiterPage />,
  },
  {
    path: "/tracker",
    loader: authLoader,
    element: <RecruiterTrackerPage />,
  },
  {
    path: "/tracker-clone",
    loader: authLoader,
    element: <RecruiterTrackerPageStatic />,
  },
  {
    path: "/requirements",
    loader: authLoader,
    element: <RequirementsLayout />,
    children: [
      {
        index: true,
        element: <Navigate to={"general"} />,
      },
      {
        path: "general",
        element: <GeneralRequirements />,
      },
      {
        path: "partner",
        element: <PartnerCompanyRequirements />,
      },
      // {
      //   path: "job/:id",
      //   element: <RequirementsDetails />,
      // },
    ],
  },
  {
    path: "requirement-details/:id",
    element: <RequirementsDetails />,
  },
  {
    path: "/hiring-company",
    loader: authLoader,
    element: <RecruiterHiringCompany />,
    children: [
      {
        path: "/hiring-company/partner-companies",
        index: true,
        element: <PartnerCompanies />,
      },
      {
        path: "/hiring-company/search-hiring-companies",
        element: <SearchHiringCompanies />,
      },
    ],
  },
  {
    path: "/calendar",
    loader: authLoader,
    element: <MeetingLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="meeting" />,
      },
      {
        path: "meeting",
        element: <CalendarsPage />,
        children: [
          {
            index: true,
            element: <Navigate to="schedules" />,
          },
          {
            path: "schedules",
            element: <ScheduleSection />,
          },
          {
            path: "schedules1",
            element: <ScheduleSection1 />,
          },
          {
            path: "scheduling",
            element: <SchedulingSection />,
          },
          {
            path: "calendar-view",
            element: <CalendarView />,
          },
        ],
      },
      {
        path: "create-meeting",
        element: <CreateMeetingInvitePage />,
      },
    ],
  },
  {
    path: "/job",
    loader: authLoader,
    element: <JobPageLayout />,
    children: [
      {
        index: true,
        element: <Navigate to={"by-job"} />,
      },
      {
        path: "by-job",
        element: <ViewByJob />,
      },
      {
        path: "by-candidate",
        element: <ViewByCandidate />,
      },
      {
        path: "by-hiring-company",
        element: <ViewByHiringCompany />,
      },
    ],
  },
  {
    path: "candidate-applied-jobs/",
    loader: authLoader,
    element: <CandidateAppliedJobPage />,
  },
  {
    path: "job/create",
    loader: authLoader,
    element: <CreateJobPage2 />,
  },
  {
    path: "job/:hiringCompanyId/:jobId/applicant-list",
    loader: authLoader,
    element: <ApplicantsListing />,
  },
  {
    path: "job/list-by-candidate/:candidateId",
    loader: authLoader,
    element: <JobListByCandidate />,
  },
  {
    path: "job/list-by-company/:companyId",
    loader: authLoader,
    element: <JobListByHiringCompany />,
  },
  {
    path: "job-applicant-detail/:jobId",
    loader: authLoader,
    element: <JobApplicantDetail />,
  },
  {
    path: "job/:jobId",
    loader: authLoader,
    element: (
      //   <ProtectedRoute allowedRoles={[2]} user={auth?.user}>
      <JobDetailPageLayout />
      //   </ProtectedRoute>
    ),
    children: [
      {
        path: "job-details",
        element: <JobDetails />,
      },
      {
        path: "applicants",
        element: <ApplicantSection />,
      },
    ],
  },
  {
    path: "/settings",
    loader: authLoader,
    element: <SettingsLayout />,
    children: [
      {
        index: true,
        element: <Navigate to={"account"} />,
      },
      {
        path: "account",
        children: [
          {
            index: true,
            element: <Navigate to={"personal-details"} />,
          },
          {
            path: "personal-details",
            element: <PersonalDetails />,
          },
          {
            path: "username",
            element: <Username />,
          },
          {
            path: "change-password",
            element: <ChangePassword />,
          },
        ],
      },
      {
        path: "company",
        children: [
          {
            index: true,
            element: <Navigate to={"company-details"} />,
          },
          {
            path: "company-details",
            element: <CompanyDetails />,
          },
          {
            path: "account-members",
            element: <AccountMembers />,
          },
        ],
      },
    ],
  },
  {
    path: "/subscription",
    loader: authLoader,
    children: [
      {
        index: true,
        element: <MySubscriptionPage />,
      },
      {
        path: "plans",
        children: [
          {
            index: true,
            element: <SubscriptionPlanPage />,
          },
          {
            path: "checkout",
            element: <SubscriptionCheckoutPage />,
          },
        ],
      },
    ],
  },
  {
    path: "/transactions",
    loader: authLoader,
    // element:<div/>
    element: <TransactionLayout />,
    children: [
      {
        index: true,
        element: <Navigate to={"payments"} />,
      },
      {
        path: "payments",
        element: <PaymentsSection />,
      },
      {
        path: "refunds",
        children: [
          {
            index: true,
            element: <RefundsSection />,
          },
          {
            // index: true,
            path: "refund-summary",
            element: <RefundSummary />,
          },
        ],
      },
      {
        path: "balance",
        element: <Balance />,
      },
      {
        path: "payment-methods",
        element: <PaymentMethod />,
      },
    ],
  },
  {
    path: "/contacts",
    loader: authLoader,
    children: [
      {
        path: "",
        element: <ContactsPageLayout />,
        children: [
          {
            path: "/contacts/candidates",
            element: <CandidateSection />,
          },
          {
            path: "/contacts/companies",
            element: <CompaniesSection />,
          },
          {
            path: "/contacts/referral",
            element: <CompaniesSection />,
          },
        ],
      },
      {
        path: "add-candidate",
        element: <AddCandidatePage />,
      },
      {
        path: "edit-candidate/:candidateId",
        element: <AddCandidatePage />,
      },
      {
        path: "add-company",
        element: <AddCompanyPage />,
      },
      {
        path: "edit-company/:companyId",
        element: <AddCompanyPage />,
      },
    ],
  },
  {
    path: "/payment/details/:id/:type",
    loader: authLoader,
    element: <TransactionDetailPage />,
  },
];
